export const NUMBER_OF_OBJECT_PER_PAGE = 10;
